import { Injectable } from '@angular/core';
import { BackendService } from '@tg4/http-infrastructure/dist/src';
import { Observable } from 'rxjs';

@Injectable()
export class ExternalClientStylesService {

    constructor(private _httpService: BackendService) {
    }

    public getAllExternalClientStyles(): Observable<any> {
        return this._httpService.get('getAllExternalClientStyles', [], [

        ]);
    }

}
